import { styled } from "@mui/material";

const PREFIX = "Introduction";

export const classes = {
  root: `${PREFIX}-root`,
  title: `${PREFIX}-title`,
  heading: `${PREFIX}-heading`,
  subheading: `${PREFIX}-subheading`,
  animals: `${PREFIX}-animals`,
  container: `${PREFIX}-container`,
  animalBackground: `${PREFIX}-animalBackground`,
  imageContainer: `${PREFIX}-imageContainer`,
  image: `${PREFIX}-image`,
  boldText: `${PREFIX}-boldText`,
  strengths: `${PREFIX}-strengths`,
  takeQuizButton: `${PREFIX}-takeQuizButton`,
};

export const CustomGrid = styled("div")(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: "100%",
    padding: 0,
  },
  [`& .${classes.title}`]: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  [`& .${classes.heading}`]: {
    display: "flex",
    justifyContent: "center",
    margin: "25px 0px",
  },
  [`& .${classes.subheading}`]: {
    padding: "10px 20px",
    "@media (max-width: 900px)": {
      padding: "10px 0px",
    },
  },
  [`& .${classes.animals}`]: {
    display: "flex",
    width: "100%",
    height: "100%",
    color: theme.palette.white.main,
    margin: "10px 0px",
    padding: "8px",
    "@media (max-width: 900px)": {
      padding: "0px",
    },
  },
  [`& .${classes.container}`]: {
    display: "flex",
    flexDirection: "column",
  },
  [`& .${classes.animalBackground}`]: {
    height: "100%",
    margin: "10px",
    padding: "20px 30px",
    textAlign: "center",
    backgroundColor: theme.palette.background.level1,
    borderRadius: "8px",
    color: theme.palette.text.main,
    "@media (max-width: 900px)": {
      margin: "10px 5px",
    },
  },
  [`& .${classes.imageContainer}`]: {
    display: "flex",
    justifyContent: "center",
    margin: "30px 0px 20px",
  },
  [`& .${classes.image}`]: {
    height: "150px",
    objectFit: "cover",
  },
  [`& .${classes.boldText}`]: {
    fontWeight: 600,
  },
  [`& .${classes.strengths}`]: {
    display: "flex",
    flexDirection: "row",
  },
  [`& .${classes.takeQuizButton}`]: {
    position: "fixed",
    bottom: 0,
    right: "20px",
    borderRadius: "8px 8px 0 0",
    height: "36px",
  },
}));
